<template>
  <e-charts
    ref="line"
    autoresize
    :options="line"
    theme="theme-color"
    auto-resize
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      line: {
        title: {
          text: 'Stacked Line',
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.optionData.xAxisData,
        },
        yAxis: {
          type: 'category',
          data: this.optionData.yAxisData,
        },
        series: this.optionData.series,
      },
    }
  },
}
</script>

<style>
.echarts {
  width: 100% !important;
}
</style>
